export default class ProductCard extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initEvents();
    }

    getSelectorInputQuantity() {
        return "input[name='product-count']";
    }

    getSelectorLinkFavorite() {
        return 'a.add-fav';
    }

    getSelectorProductCart() {
        return '.product-item';
    }

    getSelectorAddCardButtonWrapper()
    {
        return '#add_cart_boutton_wrapper';
    }

    getElementAddCardButtonWrapper()
    {
        return $(this.getSelectorAddCardButtonWrapper());
    }

    getElementProductCart() {
        return $( this.getSelectorProductCart() );
    }

    getElementInputQuantity() {
        return this.modal.find( this.getSelectorInputQuantity() );
    }

    getElementLinkFavorite() {
        return $( this.getSelectorLinkFavorite() );
    }

    getElementSelectsFeatures() {
        return $( this.getSelectorSelectsFeatures() );
    }

    getRouteChooseProductFromFeature() {
        return $('#container-select-features').data('route')
    }

    getProductParentId() {
        return this.getElementInputQuantity().data('product_parent_id');
    }

    getSelectorAddCart () {
        return '.modal .btn-add-cart';
    }

    getSelectorAddCartCard() {
        return '.txt-product .btn-add-cart';
    }

    getSelectorDecli() {
        return 'select#variant-select';
    }

    getSelectorColorModel() {
        return '.colors-models a';
    }

    getSelectorSizeModel() {
        return '.size-contain a';
    }

    getSelectorSelectColorModel() {
        return 'select[name="color"]';
    }

    getSelectorSelectSizeModel() {
        return 'select[name="size"]';
    }

    getSelectorSelectsFeatures() {
        return '#container-select-features select';
    }

    getUrlProductInfo() {
        return $('#add-cartModal').data('route_product_info');
    }

    getCartQuantity() {
        return parseInt( this.getElementInputQuantity().val() );
    }

    getProductId() {
        return this.getElementInputQuantity().data('product_id');
    }

    hideModal () {
        $('.modal').modal('hide');
    }

    onWishList() {
        return window.location.pathname === "/favoris"
    }

    addToCart () {
        HegydCore.sendRequest( this.modal.find('a.btn-add-cart').attr('href'), 'POST', {
            product_id: this.getProductId(),
            quantity: this.getCartQuantity(),
            return_templates: ['cart-header']
        }, ( data ) => {
            this.hideModal();

            Kernel.factories.Toaster( $('html'), 'success', data.message )
        });
    }

    toggleFavoris( $element ) {
        HegydCore.sendRequest( $element.attr('href'),'PUT', {}, ( data ) => {
            Kernel.factories.Toaster( $('html'), 'success', data.message );

            if( this.onWishList() ){
                this.fadeOut();
            }else{
                $element.find('.in-fav').toggle()
                $element.find('.out-fav').toggle()
            }
        })
    }

    getSelectorUpQuantity() {
        return '.btn-left';
    }

    getSelectorDownQuantity() {
        return '.btn-right';
    }

    initPluginsModal() {
        Kernel.factories.CustomSelectVariant( $('.modal') );

        $('.product-form-select select').each(function () {
            Kernel.factories.CustomSelect( $(this) );
        });
    }

    updateQuantity( $operation )
    {
        let val = parseInt( this.getElementInputQuantity().val() );

        if($operation === "+"){
            val = val + 1
        }else{
            if(val > 1){
                val = val - 1
            }
        }

        this.getElementInputQuantity().val(val)
        this.getElementInputQuantity().trigger('change');
    }

    getInfosFromFeatures() {
        var features = {};

        this.getElementSelectsFeatures().each(function () {
            features[$(this).data('feature_id')] = $(this).val();
        });

        HegydCore.sendRequest( this.getRouteChooseProductFromFeature(), 'POST',{
            parent_id: this.getProductParentId(),
            features: features
        }, data => {
            this.getElementAddCardButtonWrapper().empty().html(data.product_view_modal);
        });
    }

    initEvents() {
        $(this.getSelectorAddCartCard()).on('click', function(e){
            this.modal = $(e.target).parents('.product-item').find('.modal');

            this.modal.modal('show');
        });

        //Click sur le boutton d'ajout au panier
        $(this.getSelectorAddCart()).on('click', function(e) {
            e.preventDefault();

            this.addToCart();
        });

        /* Quantité flech up */
        $(this.getSelectorUpQuantity()).on('click', function(e){
            e.preventDefault();

            this.updateQuantity('+' );
        })

        /* Quantité flech down */
        $(this.getSelectorDownQuantity()).on('click', function(e){
            e.preventDefault();

            this.updateQuantity('-' );
        });

        /* Changement sur le selecteur de déclinaisons */
        $(this.getSelectorDecli()).on('change', function(e){
            HegydCore.sendRequest( this.getUrlProductInfo(), 'GET', {
                product_id : $(e.target).val()
            }, data => {
                $('#add-cartModal .modal-body').empty().html(data.product_view);

                this.initPluginsModal();
            });
        });

        //Click sur le boutton d'ajout aux favoris
        $(this.getSelectorLinkFavorite()).on('click', function(e) {
            e.preventDefault();

            this.toggleFavoris( $(e.target).closest(this.getSelectorLinkFavorite()));
        });

        /*Change select value color*/
        $(this.getSelectorColorModel()).on('click' , function(e){
            e.preventDefault();

            this.find( this.getSelectorSelectColorModel() ).val( $(e.target).closest( this.getSelectorColorModel() ).attr('class') );

            $( this.getSelectorSelectColorModel() ).trigger('change');
        })

        /*Change select value size*/
        $(this.getSelectorSizeModel()).on('click' , function(e){
            e.preventDefault();

            this.find( this.getSelectorSelectSizeModel() ).val( $(e.target).closest( this.getSelectorSizeModel() ).data('size') )

            $( this.getSelectorSelectSizeModel() ).trigger('change');
        })

        /*Choix d'une caracteristique*/
        $(this.getSelectorSelectsFeatures()).on('change', function(){
            this.getInfosFromFeatures();
        });
    }
}
